<template>
  <div class="article-detail-wrap">
    <div class="content">
      <div v-if="detail.type==='TEXT'">
        {{ detail.text }}
      </div>
      <div v-if="detail.type==='IMAGE'">
        <img :src="detail.image" style="width: 100%;"/>
      </div>
      <article-goods
        v-if="detail.type==='GOODS'"
        :id="detail.targetId"
      />
    </div>
    <div class="article-detail-operation">
      <a-icon type="arrow-up" class="operate-button" @click="up"/>
      <a-icon type="arrow-down" class="operate-button" @click="down"/>
      <a-icon type="close" class="operate-button" @click="remove"/>
    </div>
  </div>
</template>

<script>

import ArticleGoods from '@/views/cms/article/components/ArticleGoods.vue';

export default {
  name: 'ArticleDetailWrap',
  components: { ArticleGoods },
  props: {
    detail: Object,
  },
  methods: {
    up() {
      this.$emit('onUp');
    },
    down() {
      this.$emit('onDown');
    },
    remove() {
      this.$emit('onRemove');
    },
  },
};
</script>

<style scoped>
.article-detail-operation {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
}

.article-detail-wrap {
  background: #ffffff;
  position: relative;
  cursor: pointer;
  min-height: 64px;
  box-sizing: border-box;
  padding-right: 20px;
  padding-left: 20px;
}

.article-detail-wrap:hover .content {
  filter: blur(2px);
}

.article-detail-wrap:hover .article-detail-operation {
  display: flex;
}

.operate-button:hover {
  transform: scale(1.4);
}

.operate-button {
  font-size: 36px;
  margin: 12px;
  transition: transform .3s ease-in-out;
  will-change: transform;
  color: #36c9a3;
}

</style>
